/**
 * <PdfFallback> — un PDF qui ne s'affiche pas dans la page (web) : le dire, et proposer « Ouvrir le
 * PDF » (nouvel onglet, où le navigateur sait le lire ou l'enregistrer) et « Télécharger » — jamais
 * d'impasse (`<FlowOutcome>`). Posé par la visionneuse et par le PDF dans la page.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Button } from "../../atoms/Buttons/Button"
import { Row } from "../../atoms/containers/Row"
import { FlowOutcome } from "../FlowOutcome"
import { downloadPdf, openPdfInNewTab } from "./pdfjs"

const TEXTS = {
    failed: "Impossible d'afficher le PDF ici",
    hint: "Il reste lisible dans un nouvel onglet, ou une fois téléchargé.",
    open: "Ouvrir le PDF",
    download: "Télécharger",
}

export function PdfFallback({ uri }: { uri: string }) {
    return (
        <FlowOutcome iconName="file-pdf" message={TEXTS.failed} detail={TEXTS.hint} center>
            <Row gap="3" justify="center" style={styles.wrap}>
                <Button label={TEXTS.open} iconName="external-link-alt" onPress={() => openPdfInNewTab(uri)} />
                <Button
                    label={TEXTS.download}
                    iconName="download"
                    variant="outline"
                    onPress={() => void downloadPdf(uri)}
                />
            </Row>
        </FlowOutcome>
    )
}

const styles = StyleSheet.create(() => ({
    wrap: { flexWrap: "wrap" as const },
}))
